import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 .333a2 2 0 0 1 2 2v.06a.43.43 0 0 0 .263.395l.007.003a.43.43 0 0 0 .475-.085l.036-.037a2 2 0 0 1 2.182-.434 2 2 0 0 1 1.082 1.083 2 2 0 0 1-.434 2.18l-.037.037a.43.43 0 0 0-.084.476.7.7 0 0 1 .042.132.44.44 0 0 0 .357.19H14a2 2 0 0 1 0 4h-.059a.43.43 0 0 0-.395.263l-.612-.262.609.269a.43.43 0 0 0 .085.476l.036.036a2.005 2.005 0 0 1 .435 2.181 2 2 0 0 1-1.083 1.082 2 2 0 0 1-2.181-.433l-.036-.037a.43.43 0 0 0-.477-.084l-.062.031a.43.43 0 0 0-.206.367v.112a2 2 0 0 1-4 0v-.051a.43.43 0 0 0-.284-.39l-.04-.017a.43.43 0 0 0-.475.085l-.036.037a2.005 2.005 0 0 1-2.182.434 2 2 0 0 1-1.082-2.614 2 2 0 0 1 .434-.65l.037-.036a.43.43 0 0 0 .084-.476l-.031-.063a.43.43 0 0 0-.368-.206H2a2 2 0 0 1 0-4h.05a.43.43 0 0 0 .391-.284l.016-.039a.43.43 0 0 0-.085-.476l-.036-.036a2.003 2.003 0 0 1-.001-2.83 2 2 0 0 1 2.83 0l.036.037a.43.43 0 0 0 .477.084.7.7 0 0 1 .132-.042.44.44 0 0 0 .19-.356v-.111a2 2 0 0 1 2-2M8 5.7a2.6 2.6 0 1 0 .001 5.2A2.6 2.6 0 0 0 8 5.7"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })